import React, { Suspense, useCallback, useEffect, useState } from 'react'
import AutomationsGrid from '../../../GridList/AutomationsGrid'
import CreateAutomation from './EditAutomations/CreateAutomation';
import Card from "../../../GridList/Card";
import CreateRule from './CreateRule/CreateRule';
import ScheduledAction from './EditAutomations/ScheduledAction';
import CreateSchedule from './EditAutomations/CreateSchedule';
import { getHolidaysModesAPI, getInputRules, getSchedules, getSiteAccessRestrictions } from '../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import { Await } from 'react-router-dom';
import Oval from 'react-loading-icons/dist/esm/components/oval';

import classes from "./Automations.module.css"
import { VerifyHandler } from '../../../../store/auth-actions';
import CreateHolidayMode from './HolidayMode/CreateHolidayMode';
import CreateAccessRestriction from './CreateAccessRestriction/CreateAccessRestriction';
import useData from 'rsuite/esm/InputPicker/hooks/useData';

const Automations = ({ OutPutsPinNames, InputsPinNames, deviceData, firmware }) => {
    const numInput = deviceData.singleDeviceSettingData.numInput
    const smartLocks = deviceData.singleDeviceSettingData.iglooLocks;
    console.log(InputsPinNames)
    console.log(OutPutsPinNames)

    const [IFTTTRules, setIFTTTRules] = useState(null);
    const [schedules, setSchedules] = useState(null);
    const [holidaymode, setHolidayMode] = useState(null);
    const [siteAccessRestrictions, setSiteAccessRestrictions] = useState(null);
    const dispatch = useDispatch();

    let token = useSelector(state => state.auth.token);
    let client = useSelector(state => state.auth.client);
    let DeviceUUID = useSelector(state => state.auth.DeviceUUID);


    const apiData = {
        token,
        client
    }

    // fetchAutomations is called when an automation is Created, Edited or Deleted.
    const fetchAutomations = async () => {
        const getIFTTTRules = async () => {
            const responseData = await getInputRules(apiData, DeviceUUID)
            console.log(responseData)
            setIFTTTRules(responseData);
        }

        const getSchedulesAndReminders = async () => {
            const responseData = await getSchedules(apiData, DeviceUUID)
            console.log(responseData.data)
            setSchedules(responseData.data);
        }

        const getHolidaysMode = async ()  => {
            const responseData = await getHolidaysModesAPI(apiData, DeviceUUID)
            console.log(responseData)
            setHolidayMode(responseData);
        }

        const GetSiteAccessRestrictions = async () => {
            const responseData = await getSiteAccessRestrictions(DeviceUUID, apiData, dispatch)
            setSiteAccessRestrictions(responseData)
            console.log(responseData)
        }


        getIFTTTRules();
        getSchedulesAndReminders();
        getHolidaysMode();
        GetSiteAccessRestrictions();
    }

    // Fetch data on mount
    useEffect(() => {
        fetchAutomations();
    }, []);


    const [showAutomation, setShowAutomation] = useState(null);
    //user selects between creating a sheduledAction, reminder or a rule - 0,1 or 2
    const HandleSelectAutomation = (AutomationID) => {
        setShowAutomation(AutomationID);
    }

    //--------------------   first index is outputs, second index is inputs, third is device details--------------------------------
    const DeviceDataArray = Object.values(deviceData);

    let allListOptionsArray;

    if (numInput != 0) {
        allListOptionsArray = [...OutPutsPinNames, ...InputsPinNames];
    } else {
        allListOptionsArray = [...OutPutsPinNames];
    }

    //--------------------------------------------------------------------------------------------------------------------------------

    //use to pass the rule's pins that haven't been assigned to CreateRule component
    const [remainingrules, setRemainRules] = useState([]);

    const updateRemainRules = (rules) => {
        setRemainRules(rules)
    }

    useEffect(() => {
        console.log(schedules)
    }, [schedules])
    return (
        <div>
            <Suspense fallback={
                <div className={classes["loadingSpinner-container"]}>
                    <Oval stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} />
                </div>
            }>
                <Await resolve={Promise.all([IFTTTRules, schedules, holidaymode, siteAccessRestrictions])}>
                    {([loadedSiteRules, loadedSiteSchedules, loadedHolidaymode, loadedSiteAccessRestrictions]) =>
                        <AutomationsGrid DeviceRules={loadedSiteRules} siteSchedules={loadedSiteSchedules} siteHolidayModes={loadedHolidaymode} OutPutsPinNames={OutPutsPinNames} InputsPinNames={InputsPinNames} allListOptionsArray={allListOptionsArray} HandleSelectAutomation={HandleSelectAutomation} fetchAutomations={fetchAutomations} numInput={numInput} smartLocks={smartLocks} updateRemainRules={updateRemainRules} siteAccessRestrictions={loadedSiteAccessRestrictions} />
                    }
                </Await>
            </Suspense>
            

            {showAutomation == 2 && <CreateRule allListOptionsArray={remainingrules || allListOptionsArray} OutPutsPinNames={OutPutsPinNames} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} firmware={firmware} smartLocks={smartLocks} />}
            {(showAutomation == 0 || showAutomation == 1) && < CreateSchedule OutPutOptions={OutPutsPinNames} isReminder={showAutomation} setShowAutomation={setShowAutomation} fetchAutomations={fetchAutomations} />}

            {showAutomation === 3 && <CreateHolidayMode OutPutsPinNames={OutPutsPinNames} setShowAutomation={setShowAutomation} smartLocks={smartLocks} fetchAutomations={fetchAutomations} />}
            {showAutomation === 4 && <CreateAccessRestriction fetchAutomations={fetchAutomations}/>}
        </div>
    )
}

export default Automations